import { useAppDispatch } from 'state'
import { Text, Flex, Button, useMatchBreakpointsContext } from '@pancakeswap/uikit'
import { fetchNftPoolFarmDataAsync, fetchV2SwapAprsAsync } from 'state/xFarms'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import { getNftPoolConfigs } from 'config/constants/farms'
import React, { useEffect, useMemo, useState } from 'react'
import { TokenPairImage } from 'components/TokenImage'
import AprRange from 'components/AprRange'
import dynamic from 'next/dynamic'
import useMerklRewards from 'lib/hooks/merkl-rewards/useMerklRewards'
import useV3PoolAprs from 'hooks/v3/useV3PoolAprs'
import { useSelectMerklPools } from 'state/user/selectors'
import { useNftPoolsFarms } from 'state/xFarms/hooks'
import WrongNetworkCard from 'components/WrongNetwork/WrongNetwork'
import { getTokenInstance } from 'config/constants/token-info'
import { getTVLFormatted } from 'views/xFarms/utils'
import { FeaturedCard, HotText } from './styled'

const DEFAULT_CHAIN_ID = 8453
const FeaturedPools = [
  { address: '0x19f5828aa11e12eed05bfb435857115bd098823a', feeAmount: '80' },
  { address: '0xDad848f3F0a6BA51ffBE6e03304502E60869321D', feeAmount: '80' },
  { address: '0x74E65d5E7f820771aa86fc99e5d67578Dc77517a', feeAmount: '80' },
  { address: '0xee8092F8Da8342a07076b820d8bB553E962c182b', feeAmount: '450' },
]

const FeaturedFarms = () => {
  const { chainId, library: provider } = useActiveWeb3React()
  const dispatch = useAppDispatch()
  const { isDesktop } = useMatchBreakpointsContext()
  const { farms } = useNftPoolsFarms()
  const merklPools = useSelectMerklPools()
  useMerklRewards()

  const featuredFarmConfigs = useMemo(() => getNftPoolConfigs(chainId).filter((config) => config.featured), [chainId])
  const [featuredFarms, setFeaturedFarms] = useState([])
  useEffect(() => {
    if (chainId && featuredFarmConfigs.length > 0) {
      dispatch(fetchV2SwapAprsAsync({ chainId }))
      dispatch(fetchNftPoolFarmDataAsync({ chainId, farmConfigs: featuredFarmConfigs, provider }))
    }
  }, [chainId, dispatch, provider, featuredFarmConfigs])

  useEffect(() => {
    const filteredFarms = farms.filter((farm) => featuredFarmConfigs.some((config) => config.pid === farm.pid))
    setFeaturedFarms(filteredFarms)
  }, [farms, featuredFarmConfigs])
  const { data, status } = useV3PoolAprs(merklPools.map((p) => p.pool))

  const pools = useMemo(() => {
    return (merklPools || []).map((p) => {
      const feeAmount = p.poolFee * 10000
      const match = data ? data.find((p2) => p2.pool === p.pool) : {}
      return {
        ...p,
        feeAmount,
        ...match,
        token: getTokenInstance(p.token0),
        quoteToken: getTokenInstance(p.token1),
        tvl: getTVLFormatted(p.tvl),
      }
    })
  }, [merklPools, data])

  const featuredPoolsData = useMemo(() => {
    return FeaturedPools.map(({ address, feeAmount }) => {
      const matchingPoolData = pools.find((p) => p.pool.toLowerCase() === address.toLowerCase())
      if (matchingPoolData) {
        return {
          ...matchingPoolData,
          feeAmount,
          href: `/addV3?currencyIdA=${matchingPoolData.token.address}&currencyIdB=${matchingPoolData.quoteToken.address}&feeAmount=${feeAmount}`,
        }
      }
      return null
    }).filter((p) => p !== null)
  }, [pools])

  return (
    <Flex width="100%" alignItems="center" justifyContent="center" flexDirection="column">
      <Text fontSize="24px" textAlign="center" mb="20px">
        What's <HotText>HOT</HotText> on BaseSwap?
      </Text>
      {!chainId || chainId !== DEFAULT_CHAIN_ID ? (
        <WrongNetworkCard />
      ) : (
        <>
          <Flex flexDirection="row" flexWrap="wrap" justifyContent="space-evenly" width="100%">
            {featuredPoolsData.map((pool) => (
              <FeaturedCard key={pool.pool}>
                <TokenPairImage
                  variant="inverted"
                  primaryToken={pool.token}
                  secondaryToken={pool.quoteToken}
                  width={104}
                  height={104}
                />
                <Text fontSize="20px">{`${pool.token.symbol}-${pool.quoteToken.symbol}`}</Text>
                <Text fontSize={isDesktop ? '24px' : '18px'}>
                  APR:{' '}
                  {pool.totalAPRLabel ? (
                    pool.totalAPRLabel.includes('Infinity') || isNaN(pool.totalAPR) ? (
                      <Text textAlign="center" fontSize="14px" color="text">
                        Loading...
                      </Text>
                    ) : (
                      pool.totalAPRLabel
                    )
                  ) : (
                    <Text textAlign="center" fontSize="14px" color="text">
                      Loading...
                    </Text>
                  )}
                </Text>
                <Button width="100%" as="a" href={pool.href}>
                  Join!
                </Button>
              </FeaturedCard>
            ))}
            {/* {featuredFarms.map((farm) => (
              <FeaturedCard key={farm.pid}>
                <TokenPairImage
                  variant="inverted"
                  primaryToken={farm.token}
                  secondaryToken={farm.quoteToken}
                  width={104}
                  height={104}
                />
                <Text fontSize="20px">{farm.lpSymbol}</Text>
                <Flex>
                  {' '}
                  <AprRange farm={farm} showLabel={false} />
                </Flex>
                <Button width="100%" as="a" href={`/add/ETH/${farm.token.address}?step=1`}>
                  Join!
                </Button>
              </FeaturedCard>
            ))} */}
          </Flex>
        </>
      )}
    </Flex>
  )
}

export default FeaturedFarms
